<template>
  <v-container fill-height v-if="selectedPersonal">
    <v-row align="center" justify="center">
      <v-col cols="9" align="center" justify="center">
        <div class="font-weight-bold">Información del personal</div>

        <v-container>
          <v-row align="center">
            <v-col cols="12" align="center">
              <v-avatar rounded color="secondary" size="80" v-if="selectedPersonal && !selectedPersonal.foto">
                <v-icon x-large color="primary">mdi-account</v-icon>
              </v-avatar>
              <v-img
                v-else-if="selectedPersonal && selectedPersonal.foto"
                :src="selectedPersonal.foto"
                max-height="80"
                max-width="80"
                @error="selectedPersonal.foto = null"
              ></v-img>
            </v-col>
            <v-col cols="12" align="center" class="pb-0">
              <div class="text-subtitle-1 text--primary">
                {{
                  selectedPersonal.nombre +
                  ' ' +
                  selectedPersonal.segundoNombre +
                  ' ' +
                  selectedPersonal.apaterno +
                  ' ' +
                  selectedPersonal.amaterno
                }}
              </div>
            </v-col>
            <v-col cols="12">
              <v-divider></v-divider>
            </v-col>
            <v-col cols="12" class="py-0">
              <div class="text-subtitle-2 secondary--text">Datos generales</div>
            </v-col>
            <v-col cols="12" align="left" class="pb-0">
              <div class="text-caption mb-1">CUIP</div>
              <div class="text-body-1 text--primary">{{ selectedPersonal.CUIP }}</div>
            </v-col>
            <v-col cols="12" align="left" class="pb-0">
              <div class="text-caption mb-1">CURP</div>
              <div class="text-body-1 text--primary">{{ selectedPersonal.curp }}</div>
            </v-col>
            <v-col cols="12">
              <v-divider></v-divider>
            </v-col>
            <v-col cols="12" class="py-0">
              <div class="text-subtitle-2 secondary--text">Contacto</div>
            </v-col>
            <v-col cols="12" align="left" class="pb-0">
              <div class="text-caption mb-1">Teléfono celular</div>
              <div class="text-body-1 text--primary">{{ selectedPersonal.Contacto.telefonoCelular }}</div>
            </v-col>
            <v-col cols="12" align="left" class="pb-0">
              <div class="text-caption mb-1">Teléfono fijo</div>
              <div class="text-body-1 text--primary">{{ selectedPersonal.Contacto.telefonoFijo }}</div>
            </v-col>
            <v-col cols="12" align="left" class="pb-0">
              <div class="text-caption mb-1">E-mail</div>
              <div class="text-body-1 text--primary">{{ selectedPersonal.Contacto.correoElectronico }}</div>
            </v-col>
            <v-col cols="12">
              <v-divider></v-divider>
            </v-col>
            <v-col cols="12" class="py-0">
              <div class="text-subtitle-2 secondary--text pb-2">Registro de asistencia</div>
            </v-col>
            <v-col cols="12" align="left">
              <v-select
                v-model="asistencia"
                :items="asistenciaOpciones"
                label="Selecciona asistencia"
                outlined
                dense
                color="primary"
                class="mt-2"
                item-text="label"
                item-value="value"
                hide-details
              ></v-select>
            </v-col>
            <v-col cols="12" align="center">
              <v-btn rounded color="secondary"> Guardar cambios </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-col>
    </v-row>
  </v-container>
  <v-container v-else>
    <v-row align="center" justify="center">
      <v-col cols="12" align="center">
        <div class="text-subtitle-1 text--primary">No hay personal seleccionado</div>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
export default {
  props: {
    selectedPersonal: {
      type: Object,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      asistencia: null,
      asistenciaOpciones: [
        { label: 'Asistencia', value: 'asistencia' },
        { label: 'Ausencia', value: 'ausencia' },
        { label: 'Retardo Menor', value: 'retardo_menor' },
        { label: 'Retardo Mayor', value: 'retardo_mayor' },
        { label: 'Permiso', value: 'permiso' },
      ],
    }
  },
}
</script>
<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.card-flat {
  box-shadow: none !important;
  transition: 0.3s;
}
</style>
